import EP from './endpoints'
import api from './api'

export function fetchAllStats() {
  return api.get(EP.ALL_DASHBOARD_STATS())
}
